import React from "react";
import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import theme from "@shared/utils/themeColors";
import PaginationNumeric from "@shared/components/PaginationNumeric";
import { OrganizationCard } from "../components/OrganizationCard";
import { useOrganizations } from "../hooks/useOrganizations";

export default function Organizations() {
  const {
    organizations,
    isLoading,
    error,
    page,
    total,
    limit,
    handleSearch,
    handlePageChange,
    refresh,
  } = useOrganizations();

  return (
    <AuthenticatedLayout
      isLoading={isLoading}
      error={error ? new Error(error) : null}
      isEmpty={!organizations || organizations.length === 0}
      emptyStateProps={{
        title: "No organizations found",
        description: "There are no organizations to display",
        icon: (
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-t from-gray-200 to-gray-100 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`w-8 h-8 ${theme.text.muted}`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
              />
            </svg>
          </div>
        ),
      }}
      pageHeader={{
        title: "Organizations",
        search: {
          show: true,
          placeholder: "Search organizations...",
          onChange: handleSearch,
        },
        refresh: {
          show: true,
          onRefresh: refresh,
        },
      }}
    >
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <div className="grid grid-cols-12 gap-6">
          {organizations.map((organization) => (
            <div
              key={organization.id}
              className="col-span-full sm:col-span-6 xl:col-span-3"
            >
              <OrganizationCard organization={organization} />
            </div>
          ))}
        </div>

        <div className="mt-8">
          <PaginationNumeric
            currentPage={page}
            totalPages={Math.ceil(total / limit)}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
